(() => {
  const strings = () => window.wowthingsStrings || {};

  const getVariants = (form) => {
    const script = form.querySelector('[data-pdp-variants]');
    if (!script) return [];
    try {
      return JSON.parse(script.textContent);
    } catch (error) {
      return [];
    }
  };

  // Both picker styles write to the same `options[...]` inputs: buttons render a
  // radio group, dropdowns render a single select. Read whichever this group uses.
  const readOptionValue = (group) => {
    const select = group.querySelector('select[data-pdp-option-input]');
    if (select) return select.value;
    return group.querySelector('[data-pdp-option-input]:checked')?.value;
  };

  const getSelectedOptions = (form) => {
    const groups = Array.from(form.querySelectorAll('[data-pdp-option-position]'))
      .sort((a, b) => Number(a.dataset.pdpOptionPosition) - Number(b.dataset.pdpOptionPosition));

    return groups.map(readOptionValue);
  };

  const findVariant = (form) => {
    const variants = getVariants(form);
    const selected = getSelectedOptions(form);
    if (!selected.length) return variants.find((variant) => String(variant.id) === form.querySelector('[data-pdp-variant-id]')?.value);
    return variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
  };

  // `initial` marks the pass that runs on load. It resolves price, availability
  // and the COD block, but it must not touch the gallery: a landing template can
  // open with its ad's photograph, and jumping to the variant's colour on load
  // would scroll that opening image out of the way before it is ever seen.
  const applyVariant = (form, variant, updateUrl = true, initial = false) => {
    const idField = form.querySelector('[data-pdp-variant-id]');
    const submitButton = form.querySelector('[data-pdp-submit]');
    const availability = form.querySelector('[data-pdp-availability]');
    const codBlocks = form.querySelector('[data-pdp-cod-blocks]');
    if (codBlocks) {
      codBlocks.hidden = !variant?.available;
      codBlocks.toggleAttribute('inert', !variant?.available);
    }
    if (idField) {
      idField.value = variant ? String(variant.id) : '';
      idField.dispatchEvent(new Event('change', { bubbles: true }));
    }
    if (updateUrl) {
      const url = new URL(window.location.href);
      if (variant) url.searchParams.set('variant', variant.id);
      else url.searchParams.delete('variant');
      window.history.replaceState(window.history.state, '', url);
    }

    if (!variant) {
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = strings().unavailable ?? submitButton.textContent;
      }
      if (availability) availability.textContent = strings().unavailable ?? '';
      return;
    }

    if (submitButton) {
      submitButton.disabled = !variant.available;
      submitButton.textContent = variant.available
        ? (strings().addToCart ?? submitButton.textContent)
        : (strings().soldOut ?? submitButton.textContent);
    }
    if (availability) availability.textContent = variant.available ? '' : (strings().soldOut ?? '');

    form.dispatchEvent(new CustomEvent('pdp:variant-change', { bubbles: true, detail: { variant, initial } }));
  };

  document.addEventListener('change', (event) => {
    const input = event.target.closest('[data-pdp-option-input]');
    if (!input) return;

    const form = input.closest('[data-pdp-buy-form]');
    if (!form) return;

    applyVariant(form, findVariant(form));
  });

  document.addEventListener('pdp:variant-change', (event) => {
    const { variant, initial } = event.detail;
    const root = event.target.closest('[data-pdp-root]');
    if (!root) return;
    const priceEl = root.querySelector('[data-pdp-price]');
    const comparePriceEl = root.querySelector('[data-pdp-compare-price]');

    const discountEl = root.querySelector('[data-pdp-discount]');

    if (priceEl) priceEl.textContent = variant.price;
    if (comparePriceEl) {
      comparePriceEl.textContent = variant.comparePrice ?? '';
      comparePriceEl.hidden = !variant.comparePrice;
    }
    if (discountEl) {
      discountEl.textContent = variant.discount ? `-${variant.discount}%` : '';
      discountEl.hidden = !variant.comparePrice || !variant.discount;
    }

    if (variant.featuredImage && !initial) {
      const gallery = root.querySelector('[data-pdp-gallery]');
      const matchingThumb = gallery?.querySelector(`[data-pdp-gallery-thumb][data-media-src="${variant.featuredImage}"]`);
      matchingThumb?.click();
    }
  });

  document.addEventListener('click', (event) => {
    if (!event.target.closest('._rsi-buy-now-button')) return;
    const form = event.target.closest('[data-pdp-buy-form]') || document.querySelector('[data-pdp-root] [data-pdp-buy-form]');
    if (!form) return;
    const variant = findVariant(form);
    applyVariant(form, variant);
    if (!variant?.available || !form.reportValidity()) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  const initialize = (scope) => {
    scope.querySelectorAll('[data-pdp-buy-form]').forEach((form) => applyVariant(form, findVariant(form), false, true));
  };
  initialize(document);
  window.addEventListener('pageshow', () => initialize(document));
  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
